import { Link } from "react-router-dom";
import DramaCard from "@/components/feature/DramaCard";
import type { Drama } from "@/mocks/dramas";

type Props = {
  id?: string;
  eyebrow: string;
  title: string;
  desc: string;
  items: Drama[];
  ctaTo: string;
  ctaLabel: string;
  columnCount?: 3 | 4;
  tone?: "base" | "tint";
};

export default function DramaSection({
  id,
  eyebrow,
  title,
  desc,
  items,
  ctaTo,
  ctaLabel,
  columnCount = 4,
  tone = "base",
}: Props) {
  const gridClass =
    columnCount === 3
      ? "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"
      : "grid-cols-1 sm:grid-cols-2 lg:grid-cols-4";

  return (
    <section
      id={id}
      className={`py-16 md:py-20 ${tone === "tint" ? "bg-background-100/50" : ""}`}
      aria-label={title}
    >
      <div className="mx-auto max-w-page px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <span className="text-xs font-label tracking-[0.3em] text-primary-400">{eyebrow}</span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">{desc}</p>
          </div>
          <Link
            to={ctaTo}
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 px-4 py-2.5 text-sm font-label text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-400 cursor-pointer"
          >
            {ctaLabel}
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        <div className={`mt-10 grid gap-5 ${gridClass}`}>
          {items.map((drama) => (
            <DramaCard key={drama.id} drama={drama} />
          ))}
        </div>
      </div>
    </section>
  );
}